<template>
  <CreateTaskModal
    v-if="showTaskModal && defaultTask != null"
    v-model:visible="showTaskModal"
    :default-task="defaultTask"
    :event="event"
    @update:visible-action-modal="showTaskModal = $event"
  />
</template>

<script setup lang="ts">
import { type PropType, ref, computed } from "vue";
import {
  type EventListEventFieldsFragment,
  type GetEABShorthandsForBoardFragmentFragment,
  useCreateTaskMutation,
} from "@/graphql";
import CreateTaskModal from "@/components/event-action/task/modal/CreateTaskModal.vue";
import { createShorthandAction } from "../../helper/CreateShorthand";
import type { WorkflowEABType } from "../../helper/eabShorthandEditType";
import type { EditTaskType } from "@/components/event-action/task/helper/DefaultTask";

defineOptions({
  inheritAttrs: false,
});

const props = defineProps({
  event: {
    type: Object as PropType<EventListEventFieldsFragment>,
    required: true,
  },
  shorthand: {
    type: Object as PropType<GetEABShorthandsForBoardFragmentFragment>,
    required: true,
  },
  workflow: {
    type: Object as PropType<WorkflowEABType>,
    required: false,
    default: null,
  },
});
const { mutate } = useCreateTaskMutation({});

const showTaskModal = ref(false);

const defaultTask = ref<EditTaskType>();

function createShorthandActionFunction() {
  const task = createShorthandAction(
    props.event,
    mutate,
    props.workflow?.node.id,
    props.shorthand,
  ) as EditTaskType;
  defaultTask.value = undefined;
  if (task != null) {
    defaultTask.value = task;
    showTaskModal.value = true;
  }
}
defineExpose({
  createShorthandActionFunction,
});
computed(() =>
  props.workflow == null
    ? undefined
    : {
        placement: "right",
        title: props.workflow.description,
      },
);
</script>

<style lang="scss" scoped></style>
